import { render, staticRenderFns } from "./enterpriseInfo.vue?vue&type=template&id=73d228ff&scoped=true"
import script from "./enterpriseInfo.vue?vue&type=script&lang=js"
export * from "./enterpriseInfo.vue?vue&type=script&lang=js"
import style0 from "./enterpriseInfo.vue?vue&type=style&index=0&id=73d228ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d228ff",
  null
  
)

export default component.exports